// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");

function rndProgress(text, pct) {
  return React.createElement("span", {
              style: {
                padding: "10px"
              }
            }, "" + text + ": " + String(Math.round(pct * 100) | 0) + "%");
}

exports.rndProgress = rndProgress;
/* react Not a pure module */
